import {
  projectDeliverableFoldersPath,
  type CreateDeliverableFoldersResponse,
  type DeliverableFoldersView,
} from '@cortex/domain-project-intake-contract';
import { request } from './_request.js';

/**
 * 成果物フォルダ API クライアント。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件のデザイン成果物フォルダの種別ごとの有無を取得し、選んだ種別のフォルダを作る API クライアント
 * @graph-connects /projects/{issueKey}/deliverable-folders [calls, via:GET] 種別ごとの有無の取得
 * @graph-connects /projects/{issueKey}/deliverable-folders [calls, via:POST] 成果物フォルダの作成
 */
export const deliverableFoldersApi = {
  /** 種別ごとに、この案件のフォルダが既にあるかを取得する。 */
  view: async (issueKey: string): Promise<DeliverableFoldersView> =>
    request<DeliverableFoldersView>(projectDeliverableFoldersPath(issueKey)),
  /** 選んだ種別のフォルダを作る（種別ごとに成否が分かれることがある）。 */
  create: async (issueKey: string, types: string[]): Promise<CreateDeliverableFoldersResponse> =>
    request<CreateDeliverableFoldersResponse>(projectDeliverableFoldersPath(issueKey), {
      method: 'POST',
      body: JSON.stringify({ types }),
    }),
};
